export const USER_ACCESS_PAGES_URLS = {
  activate: '/activation',
  login: '/connexion',
  register: '/inscription',
  'register-success': '/inscription/succes',
  maintenance: '/maintenance',
  unauthorized: '/access-non-autorise',
  'password-reset-init': '/reinitialisation-mot-de-passe/demande',
  'password-reset-finish': '/reinitialisation-mot-de-passe/finalisation',
  'upgrade-subscription': '/upgrade-souscription',
  'manage-subscription': '/api/subscription/manage',
};
